export default __webpack_public_path__ + "a2186ff22f715b93e6ae122bbc880128.png";